/*
ssg
用户信息,权限处理
*/
const state = {
  // userInfo: {
  //   userid: '9b425fc573334599adac0d7a1beea506',
  //   openid:'o6R9Z01oKvw-nQDGrNVSbxQcw7jw',                                    //openId
  //   nickname: 'Armor',
  //   headimgurl: 'http://thirdwx.qlogo.cn/mmopen/PiajxSqBRaEJZRg28AUbtJAMPxIRP6eqCMRTrm1Iz0X6HdQq0CPcicRZRWvsSyUNwVDmX8tAkVVJU5wjUKPZbMqg/132',
  //   parentid: '04d373ababd14c409239aa3c07d5a632',
  //   register: 0,
  //   realname:'',                                  //用户真实姓名
  //   card:'',                                      //身份证号
  //   phone:'',                                     //手机号         1826662766
  //   phoneCode:'',                                 //手机验证码
  //   wxnumber:'',
  //   viplevel: 1                                       //1 普通用户   234是会员 
  // }
  userInfo: {
    openid:'',                                    //openId
    nickname: '',
    headimgurl: '',
    parentId: '',
    register: '',
    realname:'',                                  //用户真实姓名
    card:'',                                      //身份证号
    phone:'',                                     //手机号         1826662766
    phoneCode:'',                                 //手机验证码
    wxnumber:'',
    viplevel: 0                                   //1 普通用户   234是会员 
  }
}
const getters = {
  getUserInfo: state => state.userInfo
}
const mutations = {
  setMyUserInfo (state, userInfo) {
    state.userInfo = userInfo.userInfo
  }
}
const actions = {
  setUserInfo ({ commit, state }, userInfo) {
    commit('setMyUserInfo', { userInfo })
  }
}
export default {
  state,
  getters,
  mutations,
  actions
}


// WEBPACK FOOTER //
// ./src/store/modules/user.js